import { Box } from '@chakra-ui/react';
import { getAuthToken } from 'api/helpers';
import { SidebarContext } from 'contexts/SidebarContext';
import { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { MAIN_URL, allRoutes } from 'routes';

export default function Auth() {
    const hasToken = getAuthToken();
    const [toggleSidebar, setToggleSidebar] = useState(false);

    const getRoutes = (routes: RoutesType[]): any => {
        return routes.map((route: RoutesType, key: any) => {
            if (route.layout === '/auth') {
                return <Route path={`${route.path}`} element={route.component} key={key} />;
            } else {
                return null;
            }
        });
    };

    return hasToken ? (
        <Navigate to={MAIN_URL} />
    ) : (
        <Box>
            <SidebarContext.Provider
                value={{
                    toggleSidebar,
                    setToggleSidebar,
                }}
            >
                <Box
                    bg="white"
                    float="right"
                    minHeight="100vh"
                    height="100%"
                    position="relative"
                    w="100%"
                    transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
                    transitionDuration=".2s, .2s, .35s"
                    transitionProperty="top, bottom, width"
                    transitionTimingFunction="linear, linear, ease"
                >
                    <Box mx="auto" minH="100vh">
                        <Routes>
                            {getRoutes(allRoutes)}
                            <Route path="/" element={<Navigate to="/auth/sign-in/default" replace />} />
                        </Routes>
                    </Box>
                </Box>
            </SidebarContext.Provider>
        </Box>
    );
}
